import { createEntityAdapter, type EntityAdapter, type EntityState } from '@ngrx/entity';
import { type Action, createReducer, on } from '@ngrx/store';

import * as CdwDrawerActions from './cdw-drawer.actions';
import type { CdwDrawerEntity } from './cdw-drawer.models';

export const CDW_DRAWERS_FEATURE_KEY = 'cdwDrawer';

export interface CdwDrawersState extends EntityState<CdwDrawerEntity> {
  selectedId?: string | number; // which CdwDrawer record has been selected
  loaded: boolean; // has the CdwDrawers list been loaded
  error?: string | null; // last known error (if any)
}

export interface CdwDrawersPartialState {
  readonly [CDW_DRAWERS_FEATURE_KEY]: CdwDrawersState;
}

export const cdwDrawersAdapter: EntityAdapter<CdwDrawerEntity> = createEntityAdapter<CdwDrawerEntity>();

export const initialCdwDrawersState: CdwDrawersState = cdwDrawersAdapter.getInitialState({
  // set initial required properties
  loaded: false,
});

const createCdwDrawersReducer = createReducer(
  initialCdwDrawersState,
  on(CdwDrawerActions.loadCdwDrawersSuccess, (state, { cdwDrawers }) =>
    cdwDrawersAdapter.setAll(cdwDrawers, { ...state, loaded: true })
  ),
  on(CdwDrawerActions.closeAllDrawers, (state) =>
    cdwDrawersAdapter.map((entity: CdwDrawerEntity) => ({ ...entity, isDrawerOpen: false }), state)
  ),
  on(CdwDrawerActions.openDrawer, (state, { id }) =>
    cdwDrawersAdapter.updateOne({ id, changes: { isDrawerOpen: true } }, state)
  ),
  on(CdwDrawerActions.closeDrawer, (state, { id }) =>
    cdwDrawersAdapter.updateOne({ id, changes: { isDrawerOpen: false } }, state)
  ),
  on(CdwDrawerActions.addDrawer, (state, cdwDrawerEntity) => cdwDrawersAdapter.addOne(cdwDrawerEntity, state)),
  on(CdwDrawerActions.removeDrawer, (state, { id }) => cdwDrawersAdapter.removeOne(id, state)),
  on(CdwDrawerActions.toggleDrawer, (state, { id }) =>
    cdwDrawersAdapter.updateOne({ id, changes: { isDrawerOpen: !state.entities[id]?.isDrawerOpen } }, state)
  )
);

export function cdwDrawersReducer(state: CdwDrawersState | undefined, action: Action) {
  return createCdwDrawersReducer(state, action);
}
